import axios from "../../js/project-axios.js"

const import_ = (type, file) => {
    let formData = new FormData();
    formData.append("type", type);
    formData.append("file", file);
    return axios.post("/capital/data/import", formData, {
        timeout: 1000 * 60 * 30 // 30分钟
    });
};

const reset = retainAccount => {
    return axios.post("/capital/data/reset", {
        retainAccount
    });
}

export default {
    import: import_,
    reset
};